import { pathFor } from '../../../helpers/links';
import { CHECKOUT_PRIVATE_PARAM, CHECKOUT_VARIANT_PARAM } from '../constants';

type Query = Partial<Record<string, string | string[]>>;

export type PrivateRoomQuery = {
  slug: string;
  variantId: string;
};

const queryValue = (value: string | string[] | undefined): string | null => {
  return typeof value === 'string' && value.length > 0 ? value : null;
};

export const parsePrivateRoomQuery = (
  query: Query,
): PrivateRoomQuery | null => {
  const slug = queryValue(query[CHECKOUT_PRIVATE_PARAM]);
  const variantId = queryValue(query[CHECKOUT_VARIANT_PARAM]);

  return slug && variantId ? { slug, variantId } : null;
};

export const buildPrivateRoomQuery = ({
  slug,
  variantId,
}: PrivateRoomQuery): string => {
  return new URLSearchParams({
    [CHECKOUT_PRIVATE_PARAM]: slug,
    [CHECKOUT_VARIANT_PARAM]: variantId,
  }).toString();
};

export const privateRoomPath = (
  slug: string,
  productShopifyId: string,
): string => {
  const query = new URLSearchParams({ productId: productShopifyId });

  return `${pathFor({ page: 'PRIVATE_LINK', slug })}?${query.toString()}`;
};
